export const menuGroups = [
  {
    title: "Operaciones",
    items: [
      { path: "/BusinessUnit", label: "Unidad de Negocio" },
      { path: "/UserApiKey", label: "API Key" },
      { path: "/DbAdmin", label: "Gestión de base de datos" },
    ]
  },
  {
    title: "Marketing",
    items: [
      { path: "/SystemAlert", label: "Alertas" }
    ]
  }
];